import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer className="bg-[#241B2E] text-[#EFD9AE] px-6 py-24 md:py-32" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif text-[13vw] leading-[0.9] md:text-8xl tracking-tight"
        >
          Let's talk <span className="italic text-[#C1440E]">clean.</span>
        </motion.h2>

        <div className="mt-16 grid md:grid-cols-3 gap-10 border-t border-white/10 pt-12">
          <div>
            <div className="mb-4">
              <span className="flex flex-col leading-none">
                <span className="font-serif text-3xl">Betty Bell's</span>
                <span className="text-[0.6rem] tracking-[0.3em] uppercase text-white/50 mt-1.5">Cleaning Services LLC</span>
              </span>
            </div>
            <p className="text-white/60 text-sm max-w-xs leading-relaxed">
              Warm, meticulous cleaning for homes, offices and vacation rentals across Savannah, GA and surrounding counties.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider text-white/40 mb-3">Contact</p>
            <a href="mailto:bettybells0219@gmail.com" className="block text-white/80 hover:text-[#C1440E] transition-colors duration-300">bettybells0219@gmail.com</a>
            <a href="tel:9127046597" className="block text-white/80 hover:text-[#C1440E] transition-colors duration-300 mt-1">(912) 704-6597</a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider text-white/40 mb-3">Services</p>
            <p className="text-white/80">Residential</p>
            <p className="text-white/80">Commercial</p>
            <p className="text-white/80">Vacation Rentals</p>
          </div>
        </div>

        <p className="mt-16 text-white/40 text-sm">
          © {new Date().getFullYear()} Betty Bell's Cleaning Services. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
